import {ActionIcon, Group, Table, TextInput} from "@mantine/core";
import {IconTrash} from "@tabler/icons-react";
import type {BatchRow} from "../types";

export function BatchEntryRowChineseCharacter(props: {
  row: BatchRow;
  onUpdate: (id: string, field: keyof BatchRow, value: string) => void;
  onRemove: (id: string) => void;
}) {
  const {row, onUpdate, onRemove} = props;

  return (
    <Table.Tr>
      <Table.Td>
        <TextInput
          value={row.expression}
          onChange={e => onUpdate(row.id, "expression", e.target.value)}
          placeholder="猫"
          variant="unstyled"
          required={row.meaning !== ""}
          style={{flexGrow: 1}}
        />
      </Table.Td>
      <Table.Td>
        <Group gap={4} wrap="nowrap">
          <TextInput
            value={row.field1}
            onChange={e => onUpdate(row.id, "field1", e.target.value)}
            placeholder="māo"
            variant="unstyled"
            style={{flexGrow: 1}}
          />
        </Group>
      </Table.Td>
      <Table.Td>
        <TextInput
          value={row.meaning}
          onChange={e => onUpdate(row.id, "meaning", e.target.value)}
          placeholder="Cat"
          variant="unstyled"
          required={row.expression !== ""}
        />
      </Table.Td>
      <Table.Td>
        <TextInput
          value={row.auxiliary}
          onChange={e => onUpdate(row.id, "auxiliary", e.target.value)}
          placeholder="Radical: 犬"
          variant="unstyled"
        />
      </Table.Td>
      <Table.Td>
        <ActionIcon
          color="red"
          variant="subtle"
          onClick={() => onRemove(row.id)}
          title="Remove row"
        >
          <IconTrash size={16} />
        </ActionIcon>
      </Table.Td>
    </Table.Tr>
  );
}
